<template>
  <v-row dense>
    <v-row dense>

      <v-col cols="2">
        <!-- <v-autocomplete :no-data-text="$t('sinDatos')" v-model="promocion" id="promocion" :items="promociones"
          :label="localizationFiltros.promocion"
          item-text="name"
          item-value="id"
          :disabled="disabled"
          clearable
          @change="inmueble = null"
        />  -->
        <div @click="mostrarPopupPromociones()" >
            <v-autocomplete :no-data-text="$t('sinDatos')"
              v-model="promocion" id="promocion"
              :items="promociones"
              :label="localizationFiltros.promocion"
              item-value="id"
              item-text="name"
              :disabled="disabled"
              readonly
              multiple
              @change="popupPromociones($event)"
              >
            </v-autocomplete>
            </div>
      </v-col>
      <v-col cols="2">
        <v-row justify="space-between" align="center" no-gutters>

          <v-col cols="9" lg="10"
            v-if="inmuebles.length === 0"
            @click="promocion && promocion.length === 1 ? mostrarSeleccionarInmuebles = true : null"
            :style="promocion ? 'cursor: pointer !important' : ''"
          >
            <v-text-field :label="localizationFiltros.inmueble"
              :disabled="!promocion || disabled || promocion.length > 1" readonly />
          </v-col>
          <v-col cols="9" lg="10" v-else>
            <v-autocomplete :no-data-text="$t('sinDatos')" 
              :items="inmueblesSeleccionadosConId.length > 0 ? inmueblesSeleccionadosConId : []"
              v-model="inmueblesSeleccionadosConId" id="inmueblesSeleccionadosConId" 
              :disabled="!promocion || disabled || promocion.length > 1"
              :label="localizationFiltros.inmueble"  
              item-value="id"
              item-text="inmuebleDesc"
              return-object multiple clearable >
                  <template v-slot:selection="data">
                    <div v-if="inmuebles.length === 1" >
                        {{ limpiarNombre(data.item)}}
                    </div>
                    <div v-else-if="inmuebles.length < 5" >
                        {{ limpiarNombre(data.item) + ","}}
                    </div>
                    <div v-else-if="inmuebles.length >= 1 && data.index === 0">
                        {{ `${inmuebles.length} ${$t('popUpSeleccionarInmueble.itemsSeleccionados')}` }}
                    </div>
                </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="3" lg="2">
            <v-btn color="primary" text icon large
              @click="mostrarSeleccionarInmuebles = true"
              :disabled="!promocion || disabled || promocion.length > 1">
              <v-icon>search</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="2">
        <v-text-field v-model="referencia" id="referencia" clearable
            :label="$t('sectionInformes.filtros.numIncidencia')"
            :rules="[rules.integerNumber0]"></v-text-field>
      </v-col>

      <v-col cols="2">
        <v-autocomplete :no-data-text="$t('sinDatos')" v-model="estado" id="estado" :label="localizationFiltros.estadoEncuesta"
          :items="estados" item-text="text" item-value="id"
          clearable :disabled="disabled">
        </v-autocomplete>
      </v-col>

      <v-col cols="2">
        <v-autocomplete :no-data-text="$t('sinDatos')" v-model="valoracion" id="valoracion" :label="localizationFiltros.valoracion"
          :items="getValoraciones" 
          :item-text="textoValoracion" 
          item-value="id" multiple
          clearable :disabled="disabled">
        </v-autocomplete>
      </v-col>

      <v-col cols="2">
        <v-autocomplete :no-data-text="$t('sinDatos')" v-model="respuesta" id="respuesta" :label="localizationFiltros.respuesta"
          :items="respuestas" item-text="descripcion" item-value="id"
          clearable :disabled="disabled">
        </v-autocomplete>
      </v-col>
      <v-col cols="3">
        <v-row no-gutters>
          <v-col cols="12">
            <span class="v-label theme--light">
              {{ localizationFiltros.fechaEncuesta }}
            </span>
          </v-col>
          <v-col cols="12">
            <o-date-picker v-model="encuestaDesde" id="encuestaDesde" :label="localizationFiltros.desde"
              :disabled="disabled" :max="encuestaHasta" />
          </v-col>
          <v-col cols="12">
            <o-date-picker v-model="encuestaHasta" id="encuestaHasta" :label="localizationFiltros.hasta"
              :disabled="disabled" :min="encuestaDesde" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-row no-gutters>
          <v-col cols="12">
            <span class="v-label theme--light">
              {{ localizationFiltros.fechaIncidencia }}
            </span>
          </v-col>
          <v-col cols="12">
            <o-date-picker v-model="incidenciaDesde" id="incidenciaDesde" :label="localizationFiltros.desde"
              :disabled="disabled" :max="incidenciaHasta" />
          </v-col>
          <v-col cols="12">
            <o-date-picker v-model="incidenciaHasta" id="incidenciaHasta" :label="localizationFiltros.hasta"
              :disabled="disabled" :min="incidenciaDesde" />
          </v-col>
        </v-row>
      </v-col>

    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-row justify="space-between" align="end">
          <v-col cols="4">
            <v-row justify="space-between" align="end">
              <v-col cols="6">
                <v-btn @click="exportarExcel"
                  color="primary" :disabled="disabled">
                  {{localizationFiltros.excel}}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-btn-toggle v-model="toggle" id="toggle" @change="untoggle">
            <v-btn active-class="none" style="opacity: 1"
              :disabled="disabled" @click="borrarFiltros">
              {{localizationFiltros.borrar}}
            </v-btn>
            <v-btn active-class="none" style="opacity: 1"
              :disabled="disabled" @click="aplicarFiltros" color="primary">
              {{localizationFiltros.aplicar}}
            </v-btn>
          </v-btn-toggle>
        </v-row>
      </v-col>
    </v-row>
    <v-fade-transition>
      <custom-dialog  v-if="mostrarSeleccionarInmuebles"
        v-model="mostrarSeleccionarInmuebles" id="mostrarSeleccionarInmuebles"
        @aceptar="mostrarSeleccionarInmuebles = $event">
        <PopUpSeleccionarInmuebles  :yaSeleccionado="inmuebles" :promoId="(promocion.length > 0 ? promocion : '')"
          :multiple="true" @selected="inmuebles = $event" :incidencias="true" />
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <custom-dialog
        v-if="mostrarSeleccionarPromociones"
        v-model="mostrarSeleccionarPromociones" id="mostrarSeleccionarPromociones"
      >
        <PopUpSeleccionarPromociones
          :multiple="true"
          @selected="popupSeleccionarPromociones($event)"
        />
      </custom-dialog>
    </v-fade-transition>
  </v-row>
</template>

<script>
import PopUpSeleccionarInmuebles from '@/components/incidencias/PopUpSeleccionarInmuebles'
import { mapGetters, mapActions } from 'vuex'
import rulesMixin from '@/components/generic/rules.js'
import PopUpSeleccionarPromociones from '../incidencias/maestros/PopUpSeleccionarPromociones'

export default {
  mixins: [
    rulesMixin
  ],
  components: {
    PopUpSeleccionarInmuebles,
    PopUpSeleccionarPromociones
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      toggle: null,
      mostrarSeleccionarInmuebles: false,
      promocion: [],
      inmuebles: [],
      estado: null,
      incidenciaDesde: null,
      incidenciaHasta: null,
      encuestaDesde: null,
      encuestaHasta: null,
      valoracion: [],
      respuesta: 0,
      mostrarSeleccionarPromociones: false,
      referencia: null
    }
  },
  created () {
    this.loadConfiguracion()
    this.obtenerValoraciones()
  },
  computed: {
    ...mapGetters({
      promocionesIdubapi: 'incidencias/getPromocionesIdubapi',
      getValoraciones: 'informes/getValoraciones'
    }),
    localizationFiltros () {
      return this.$t('sectionInformes.filtros')
    },
    objFiltrosParaApi () {
      const idInmuebles = this.inmuebles.filter(x => x.inmuebleId !== null).map(x => {
        return x.inmuebleId
      })
      const idInmueblesEspeciales = this.inmuebles.filter(x => x.inmuebleEspecialId !== null).map(x => {
        return x.inmuebleEspecialId
      })

      return {
        InmuebleIdSelected: idInmuebles,
        InmuebleEspecialIdSelected: idInmueblesEspeciales,
        propertyDevelopment: this.promocion,
        status: this.estado ? this.estado : null,
        export_csv: 0,
        encuestaDesde: this.encuestaDesde,
        encuestaHasta: this.encuestaHasta,
        incidenciaDesde: this.incidenciaDesde,
        incidenciaHasta: this.incidenciaHasta,
        valoracion: this.valoracion,
        respuesta: this.respuesta || 0,
        referencia: this.referencia
      }
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    estados () {
      if (this.$store.state.incidencias.estados && this.$store.state.incidencias.estados.length > 0) {
        let estadosAux = []
        this.$store.state.incidencias.estados.forEach(estado => {
          if(estado.code == 30 || estado.code == 50) {
            estadosAux.push(estado)
          }
        })
        return estadosAux.map(x => {
          return {
            ...x,
            text: x.code + ' - ' + x.translates[this.usuario.idioma]
          }
        })
      }
      return []
    },
    promociones () {
      if (this.$store.state.incidencias.promociones) {
        return this.$store.state.incidencias.promociones
      }
      return []
    },
    respuestas () {
      return [
        {
          id: 0,
          descripcion: this.localizationFiltros.todas
        },
        {
          id: 1,
          descripcion: this.localizationFiltros.encuestasRespondidas
        },
        {
          id: 2,
          descripcion: this.localizationFiltros.encuestasSinResponder
        }

      ]
    },
    inmueblesSeleccionadosConId: {
      get () {
        return this.inmuebles.map(x => {
          return {
            ...x,
            inmuebleDesc: x.inmuebleId != null ? (x.uhedit + ' - ' + x.direccion) : (x.nomInmueble),
            id: x.inmuebleId != null ? x.inmuebleId: x.inmuebleEspecialId
          }
        })
      },
      set (value) {
        return value
      }
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadConfiguracion: 'configuracion/obtenerConfiguracion',
      getProvidersByPropertyDevAndProfession: 'incidencias/getProvidersByPropertyDevAndProfession',
      obtenerValoraciones: 'informes/obtenerValoraciones'

    }),
    async untoggle () {
      await this.$nextTick()
      this.toggle = null
    },
    aplicarFiltros () {
      this.$emit('aplicar', this.objFiltrosParaApi)
    },
    borrarFiltros () {
      this.reiniciarFiltros()
      this.$emit('borrar', this.objFiltrosParaApi)
    },
    exportarExcel () {
      this.$emit('exportar', {
        ...this.objFiltrosParaApi,
        export_csv: 1
      })
    },
    reiniciarFiltros () {
      this.promocion = []
      this.inmuebles = []
      this.estado = null
      this.encuestaDesde = null
      this.encuestaHasta = null
      this.incidenciaDesde = null
      this.incidenciaHasta = null
      this.respuesta = null
      this.valoracion = []
    },
    limpiarNombre(item) {
      return item.nomInmueble.replace("<br>", " ")
    },
    mostrarPopupPromociones () {
      if ( this.mostrarSeleccionarPromociones === false ) {
        this.mostrarSeleccionarPromociones = true
      }
      else {
        this.mostrarSeleccionarPromociones = false
      }
    },
    popupSeleccionarPromociones (promocionesSelected) {
      this.inmueble = null
      if (promocionesSelected != null && promocionesSelected.length > 0) {
        this.promocion =  promocionesSelected.map( x => x.id)
      } else {
        this.promocion = []
      }
    },
    textoValoracion(item) {
      let desc = item.translates[this.usuario.idioma] || item.descripcion
      return `${item.valor} - ${desc}`
    }
  },
  watch: {
    'promocion': function () {
      let items = {
        professionId: this.oficio,
        propertyDevelopmentId: ( this.promocion.length > 0 ? this.promocion : '')
      }
      this.getProvidersByPropertyDevAndProfession(items)
    },
  }
}
</script>

